import React from "react";

export default function SmsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 22 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#currentColor"
        d="M2.75 1.373a1.376 1.376 0 0 0-1.375 1.373v10.986a1.372 1.372 0 0 0 1.375 1.373h13.18c.73 0 1.43.29 1.945.805l2.75 2.746V2.746a1.373 1.373 0 0 0-1.375-1.373H2.75ZM19.25 0A2.752 2.752 0 0 1 22 2.746v17.568a.686.686 0 0 1-1.174.484l-3.923-3.917a1.376 1.376 0 0 0-.972-.403H2.75A2.752 2.752 0 0 1 0 13.732V2.746A2.745 2.745 0 0 1 2.75 0h16.5Z"
      />
      <path
        fill="#currentColor"
        d="M4 4.667c0-.177.074-.347.205-.472A.718.718 0 0 1 4.7 4h12.6c.186 0 .364.07.495.195a.65.65 0 0 1 .205.472.65.65 0 0 1-.205.471.718.718 0 0 1-.495.195H4.7a.718.718 0 0 1-.495-.195A.65.65 0 0 1 4 4.667ZM4 8a.65.65 0 0 1 .205-.471.718.718 0 0 1 .495-.196h12.6c.186 0 .364.07.495.196A.65.65 0 0 1 18 8a.65.65 0 0 1-.205.471.718.718 0 0 1-.495.196H4.7a.718.718 0 0 1-.495-.196A.65.65 0 0 1 4 8Zm0 3.333c0-.177.074-.346.205-.471a.718.718 0 0 1 .495-.195h7c.186 0 .364.07.495.195a.651.651 0 0 1 .205.471.65.65 0 0 1-.205.472.718.718 0 0 1-.495.195h-7a.718.718 0 0 1-.495-.195.65.65 0 0 1-.205-.472Z"
      />
    </svg>
  );
}
